import { ComponentProps, CSSProperties } from "react";
import { cn } from "@/lib";

interface DividerProps extends ComponentProps<"div"> {
  thickness?: number;
  color?: string;
  width?: CSSProperties["width"];
}

export const Divider = ({ thickness, className, ...props }: DividerProps) => {
  return (
    <div
      {...props}
      className={cn("w-full bg-divider", className)}
      style={{
        height: thickness ?? 2,
        minHeight: thickness ?? 2,
      }}
    />
  );
};
